var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBehance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_7464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6755 0.550781H4.31227C2.23486 0.550781 0.550781 2.23486 0.550781 4.31227V28.673C0.550781 30.7504 2.23486 32.4345 4.31227 32.4345H28.6755C30.753 32.4345 32.437 30.7504 32.437 28.673V4.31227C32.437 2.23486 30.753 0.550781 28.6755 0.550781Z",
    fill: "url(#paint0_linear_2013_7464)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5696 15.5393C13.5696 15.5393 16.2766 15.3382 16.2766 12.1645C16.2766 8.99086 14.062 7.44141 11.257 7.44141H2.02734V25.1789H11.257C11.257 25.1789 16.8902 25.3568 16.8902 19.9427C16.8902 19.9427 17.1377 15.5393 13.5696 15.5393ZM6.09305 10.5945H11.2493C11.2493 10.5945 12.5048 10.5945 12.5048 12.4404C12.5048 14.2863 11.7675 14.5545 10.9296 14.5545H6.09562L6.09305 10.5945ZM11.0173 22.0259H6.09562V17.2873H11.2519C11.2519 17.2873 13.121 17.2615 13.121 19.7236C13.1262 21.7732 11.7598 22.0052 11.0198 22.0259H11.0173ZM24.4055 11.9557C17.5838 11.9557 17.5915 18.7697 17.5915 18.7697C17.5915 18.7697 17.1223 25.5502 24.4055 25.5502C24.4055 25.5502 30.4744 25.8956 30.4744 20.8348H27.3548C27.3548 20.8348 27.458 22.7426 24.5189 22.7426C24.5189 22.7426 21.3968 22.9514 21.3968 19.6488H30.5878C30.5878 19.6488 31.5855 11.9557 24.4055 11.9557ZM27.1795 17.2873H21.353C21.353 17.2873 21.7345 14.5545 24.4751 14.5545C27.2156 14.5545 27.1795 17.2873 27.1795 17.2873ZM20.5898 8.48812H27.9066V10.6718H20.5898V8.48812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2013_7464",
    x1: 16.4939,
    y1: 0.550781,
    x2: 16.4939,
    y2: 32.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0047AD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_7464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.00beb59f833cb42b90103769be023724.svg";
export { ForwardRef as ReactComponent };